'use strict';

//var ioClient = require('socket.io-client');
//var ss = require('socket.io-stream');

const socketApi = require('socketapi');
const socketApiLegacy = require('socketapilegacy');
var EventEmitter = require('events');
var debug = require('debug')('lcp-client:info');
var debugTiming = require('debug')('lcp-client:timing');
var fetch = require('isomorphic-fetch');

/*JSON RPC2.0 error codes, see: http://www.jsonrpc.org/specification#error_object
 * Keep in sync with lcp client communication*/
var errorCodes = {
  '-32601': 'Method not found',
  '-32602': 'Invalid params',
  '-32603': 'Internal error',
  '-32100': 'Timeout in request',
  '-32101': 'Device runtime error'
}

var transactionID = 1;
var transactionIdMap = {}; // key is tr id, content is callback function
var timeout = 7000; // timeout request after 7 seconds

var getTimeStamp = function () {
  try {
    return performance.now();
  } catch (err) {
    return new Date().getTime();
  }
}


function getNewTransactionId(callback, method) {
  var id = transactionID++;
  var timer = setTimeout(function () {
    delete transactionIdMap[id];
    if (callback) callback({ code: -32100, error: errorCodes[-32100] }, undefined);
  }, timeout);
  transactionIdMap[id] = { callback: callback, timer: timer, ts: getTimeStamp(), method: method };
  return id;
}

function getCallbackForTransactionId(id) {
  var obj = transactionIdMap[id];
  if (obj && obj.timer) {
    clearTimeout(obj.timer);
    debugTiming("Call to " + obj.method + " took " + (getTimeStamp() - obj.ts) + "ms");
  }
  if (obj && obj.callback) {
    delete transactionIdMap[id];
    return obj.callback;
  }

  return function () { };
}

var Api = new EventEmitter();
var deviceList = {}
var reSubscribeEnabled = false;

var reSubscribe = function (devId) {
  debug("lcp-client-communication: reSubscribe");
  if (deviceList[devId] && deviceList[devId].reSubscribe && reSubscribeEnabled) {
    var subs = [];

    var arrayCb = null;

    for (var k in deviceList[devId].subscriptions) {
      var s = deviceList[devId].subscriptions[k];

      if (!arrayCb || arrayCb === s.callback) {
        arrayCb = s.callback;
        subs.push({ 'name': s.event.name, 'options': s.event.options })
      } else {
        if (subs.length) {
          if (subs.length === 1) subs = subs[0];
          Api.subscribeTo(devId, subs, arrayCb);
          subs = [];
          arrayCb = null;
        }
        Api.subscribeTo(devId, { 'name': s.event.name, 'options': s.event.options }, s.callback);
      }
    }

    if (subs) {
      if (subs.length === 1) subs = subs[0];
      Api.subscribeTo(devId, subs, arrayCb);
    }

    deviceList[devId].reSubscribe = null;
  }
}

var genericMsgHandler = function (obj, socket, stream) {
  //debug('message', obj);
  //console.log("genericMsgHandler:", obj, socket);
  //console.log(obj);
  if (obj.id === undefined) { // notification
    if (!obj.from || typeof obj.from !== 'string') throw new Error("message.from must be a string");
    if (typeof obj.method !== 'string') throw Error("message.method must be a string");
    switch (obj.method) {
      case 'device-connected':
        if (Api.connectedDevices.indexOf(obj.from) === -1) Api.connectedDevices.push(obj.from)
        Api.emit('device-connected', obj.from);
        reSubscribe(obj.from);
        break;
      case 'device-disconnected':
        //console.log("deviceList", deviceList);
        var device = deviceList[obj.from];
        //console.log(device);
        //console.log("DEBUG:",device.socket.id,socket.id);
        if (device.socket && device.socket.id === socket.id) {
          Api.connectedDevices.splice(Api.connectedDevices.indexOf(obj.from), 1);
          deviceList[obj.from].reSubscribe = true;
          Api.emit('device-disconnected', obj.from);
        } else {
          console.log("Disconnect received from old socket");

        }
        break;
      default:
        Api.emit(obj.method, obj.from, obj.params, obj.method);
        break;
    }
  } else if (obj.result !== undefined || obj.error !== undefined) { // it is a response to request
    if (obj.error !== undefined) {
      obj.error = { message: obj.error, code: obj.code };
    }
    getCallbackForTransactionId(obj.id)(obj.error, obj.result, stream);
  } else { // it is a request from the server
    throw new Error('ERROR: request from the server is not implemented');
  }
}

/* device List contains all devices user has access
  {   id:<id>,
    server:<url>,
    socket:<socket.io socket>,
    streamSocket:<socket.io streamSocket>,
    connection:<socket connection status>,
    deviceConnection:<deviceConnection status>,
    subscriptions:<subscribed variables>,
    reSubscribe:<whether client needs to rescubscribe>
  }
*/

//console.log("SocketApi",socketApi);
//socketApi.helloWorld();
//Api.socketStream = socketApi.getSS(); 
Api.errorCodes = errorCodes;
Api.connectedDevices = [];
var ioManagers = {};
// state will be set connection_called when connect is called first time, because user of lib does not have to call connect again -> this can be used
// for instance in UI routechange event to check if there is need to call connect
Api.state = 'disconnected';

Api.disconnect = function () {
  Api.state = 'disconnected';
  for (var id in deviceList) {
    Api.leaveDevice(id);
  }
  ioManagers = {};
}

var currentConf;

var ready = function () { };

var socketConnectionInit = function (socketConf, deviceId) {
  if (!socketConf.token) throw new Error('token is not defined')
  var device = deviceList[deviceId];
  //console.log("socket:",device.socket);
  if (device.socket) {
    device.socket.connect();
    return;
  }
  var reconnectionCount = 0;
  var params = '?token=' + socketConf.token;
  if (socketConf.autoJoin !== undefined) params += "&autoJoin=" + socketConf.autoJoin;
  debug('lcp-client-communication: connecting socket to:', device.server + "/" + device.id + params);
  //console.log('lcp-client-communication: connecting socket to:', device.server + "/" + device.id + params);

  // Client might have separate auth tokens for devices -> in that case we cannot use same websocket connection
  //  if separateDeviceConnection is true, make sure that we create own connection for device
  var serverConnectionIdentifier = socketConf.separateDeviceConnection ? device.server + "_" + deviceId : device.server;
  //console.log("serverConnectionIdentifier:", serverConnectionIdentifier);
  //if (!ioManagers[serverConnectionIdentifier]) {
  //console.log("DEEEEEBUUUFG:",device.server,params);
  var socketClient = null;
  if (device.server == "https://iot-socket1.flowone.io" ||
    device.server == "https://iot-socket2.flowone.io" ||
    device.server == "https://iot-socket3.flowone.io" ||
    device.server == "https://iot-socket1.testflowone.io") {
    socketClient = socketApiLegacy;
    console.log("Using legacy socket.io client!");
  } else {
    socketClient = socketApi;
    console.log("Using newest socket.io client");
  }
  //DEBUG REMOVE
  //device.server='http://localhost:3010'
  //DEBUG REMOVE END
  ioManagers[serverConnectionIdentifier] = socketClient.getManager(device.server + params, {
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 120000, //120sec is maximum time for reconnect,
    timeout: 20000, // for connect error
    transports: ['websocket']
    //max reconnection attemps and force new connection does not exist in socket.io 1.0 ?
  });
  //}
  var socket = ioManagers[serverConnectionIdentifier].socket('/' + device.id);
  device.socket = socket;
  if (socket.disconnected) socket.connect();
  socket.on('reconnect_attempt', function () {
    reconnectionCount++;
    debug('lcp-client-communication: ' + device.id + ' reconnecting count:', reconnectionCount);
  });
  var ss = socketClient.getSS();
  device.streamSocket = ss(socket);
  socket.on('connect', function () {
    debug("lcp-client-communication: socket connected: ", device.id);
    Api.emit("socket-connected", device.id);
    if (deviceList[deviceId].connectCb) {
      deviceList[deviceId].connectCb();
      delete deviceList[deviceId].connectCb
    }
    reconnectionCount = 0;
  });

  socket.on('message', function (obj) {
    genericMsgHandler(obj, socket);
  });

  socket.on('version-info', function (data) {
    Api.emit("version-info", data);
  });

  ss(socket).on('stream', function (stream, data) {
    debug('lcp-client-communication:stream received', data);
    genericMsgHandler(data, socket, stream);
  });

  ss(socket).on('error', function (err) {
    console.log('ss error:' + err);
  });

  socket.on('disconnect', function () {
    debug('lcp-client-communication: socket disconnected.');
    Api.emit("socket-disconnected", device.id);
    Api.emit("device-disconnected", device.id);
    if (deviceList[deviceId].disconnectCb) {
      deviceList[deviceId].disconnectCb();
      delete deviceList[deviceId].disconnectCb
    }
  });

  socket.on('error', function (err) {
    console.log('error:' + err);
    console.log('disconnect socket');
    socket.disconnect();
    if (err.message && err.message.indexOf("token decode failed") > -1) {
      setTimeout(function () {
        debug('token expired, reconnecting...');
        Api.connect(currentConf);
      }, 10000);
    }
    /*else if () {
      setTimeout(function () {
        debug('lcp-client-communication: reconnecting...');
        socketConnectionInit(socketConf, device.id);
      }, 10000);
    } */
    else {
      Api.emit('error', err);
    }
  });

  ready(Api);
};

Api.serviceConnect = function (conf) {
  currentConf = conf;
  conf.token = conf.serviceToken;
  timeout = conf.timeout || 7000;
  if (!deviceList[conf.deviceId]) deviceList[conf.deviceId] = { server: conf.server, id: conf.deviceId };
  socketConnectionInit(conf, conf.deviceId);
}


Api.connect = function (conf) {
  currentConf = conf;
  Api.state = 'connection_called';
  var url = conf.url || 'https://api.lcp.io:443';
  ready = conf.onReady || function () { };
  var clientType = conf.clienttype || "client";
  timeout = conf.timeout || 7000;

  var params = {
    type: clientType,
    tag: conf.tag,
    system: conf.system,
    devices: conf.devices // do not return devices by default
  };
  // if we have token, we have lighter method to do authentication
  if (conf.token) {
    params.token = conf.token;
  } else {
    params.username = conf.username;
    params.password = conf.password;
  }

  return fetch(url + '/login', {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(params)
  })
    // Convert to JSON
    .then((response) => {
      if (response.ok) {
        return response.json()
      }
      var err = new Error(response.statusText);
      err.status = response.status
      throw err;
    })
    // Login
    .then((json) => {

      //response.token should be used when creating socket connection
      // response.devices contain plain list of devices which are available through socket
      Api.devices = json.devices || [];
      conf.token = json.token;
      //conf.socketServerUrl = response.socketServerUrl;
      for (var i = 0; i < Api.devices.length; i++) {
        if (!deviceList[Api.devices[i].id]) {
          deviceList[Api.devices[i].id] = Api.devices[i];
        }
      }
      //console.log("Api.connect devicesList:",deviceList);
      if (conf.autoJoin === undefined || conf.autoJoin === true) {
        console.log("joinDevices", conf);
        for (var id in deviceList) {
          socketConnectionInit(conf, id);
        }

      }
      debug('lcp-client-communication: authenticated');
      Api.emit('authenticated', { token: conf.token, socketServerUrl: json.socketServerUrl });
    })
    // Handle error
    .catch(err => {
      if (err instanceof Error) {
        debug("/authentication ERROR:", err.statusCode);
        debug('lcp-client-communication: authentication-error', err.statusCode);
        Api.emit('authentication-error', { httpStatusCode: err.status, error: err.message });
      }
    })

}

/**
 * Join device and return promise that is resolved on completion
 * param options:
 * joinDevice(deviceId)
 * joinDevice(deviceId, socketServer)
 */
Api.joinDevice = function (deviceId, socketServer) {
  return new Promise((resolve, reject) => {
    if (!deviceList[deviceId] && socketServer) {
      deviceList[deviceId] = { id: deviceId, server: socketServer }
    }


    var addCallbackHandler = function () {
      var timer, errCallback;

      var cleanup = function () {
        Api.removeListener('error', errCallback);
        delete deviceList[deviceId].connectCb
      }

      errCallback = function (err) {
        clearTimeout(timer)
        cleanup()
        reject(new Error(err));
      }

      timer = setTimeout(function () {
        cleanup()
        reject(new Error('timeout'))
      }, 15000)

      Api.on('error', errCallback)
      deviceList[deviceId].connectCb = function () {
        clearTimeout(timer)
        cleanup()
        resolve();
      }
    }

    if (deviceList[deviceId]) {
      // if device is already connected
      if (deviceList[deviceId].socket && !deviceList[deviceId].socket.disconnected) {
        setTimeout(function () { Api.emit('socket-connected', deviceId); resolve() }, 0);
        return
      }
      addCallbackHandler()
      socketConnectionInit(currentConf, deviceId);
      //Api.emitCustom(deviceId,'join-device',deviceId);
    } else {
      // TODO this breaks scalability, since server should be per device
      console.log('currentConf', currentConf);
      deviceList[deviceId] = { server: 'https://s2.lcp.io:443', id: deviceId }
      addCallbackHandler()
      socketConnectionInit(currentConf, deviceId);
    }
  })
}

/**
 * Leave device and return promise that is resolved on completion
 * param options:
 * joinDevice(deviceId)
 * joinDevice(deviceId, callback)
 */
Api.leaveDevice = function (deviceId) {
  return new Promise((resolve, reject) => {
    if (deviceList[deviceId]) {
      delete deviceList[deviceId].subscriptions;

      if (deviceList[deviceId].socket) {
        var timer = setTimeout(function () {
          delete deviceList[deviceId].disconnectCb
          reject(new Error('timeout'))
        }, 15000)
        deviceList[deviceId].disconnectCb = function () {
          clearTimeout(timer)
          delete deviceList[deviceId];
          resolve();
        }
        deviceList[deviceId].socket.disconnect();
      }
    }
  })
}

// for emitting custom messages
Api.emitCustom = function (deviceId, method, msg) {
  deviceList[deviceId].socket.emit(method, msg);
}

Api.setDevice = function (deviceId) {
  Api.defaultDevice = deviceId;
}

Api.requestVersion = function (deviceId, cb) {
  Api.requestTo(deviceId, "version-info", null, function (err, resp) {
    if (err) return console.log("version-info err", err);
    cb(resp);
  });
}

Api.requestTo = function (devId, method, params, responseCallBack) {
  if (!deviceList[devId]) throw new Error('Device not joined to socket. Call joinDevice first')
  if (!deviceList[devId].socket) { debug("lcp-client-communication: Socket Not available"); return; }
  if (!devId) throw new Error("deviceId not set");
  if (typeof method !== 'string') throw Error("method must be a string");
  if (params === undefined) throw Error("params not set"); // params could be optional, but currently params is used at server method validation, so it needs to be set.
  var id = getNewTransactionId(responseCallBack, method);
  var msg = {
    to: devId,
    id: id,
    method: method,
    params: params
  }
  //debug("lcp-client-communication: sending message:", msg);
  deviceList[devId].socket.emit('message', msg);
}

Api.request = function (method, message, responseCallBack) {
  Api.requestTo(Api.defaultDevice, method, message, responseCallBack);
}

var addSubscription = function (devId, event, cb) {
  //if (!deviceList[devId].connection) throw "device not joined"
  if (!deviceList[devId].subscriptions) {
    deviceList[devId].subscriptions = {};
  }

  if (event instanceof Array) {
    for (var i = 0; i < event.length; i++) {
      deviceList[devId].subscriptions[event[i].name] = { event: event[i], callback: cb };
    }
  } else if (event.name) {
    deviceList[devId].subscriptions[event.name] = { event: event, callback: cb };
  } else {
    deviceList[devId].subscriptions[event] = { 'event': { 'name': event }, callback: cb };
  }
}


Api.subscribeTo = function (devId, event, responseCallBack) {
  if (!devId) throw new Error("deviceId not set");
  if (!deviceList[devId].socket) { debug("lcp-client-communication: Socket Not available"); return; }
  Api.requestTo(devId, 'subscribe', event, responseCallBack);
  addSubscription(devId, event, responseCallBack);
}


Api.subscribe = function (event, responseCallBack) {
  Api.subscribeTo(Api.defaultDevice, event, responseCallBack);
}

//Aliases
Api.sendTo = Api.requestTo;
Api.send = Api.request;
// stream request are just normal request, it's up to device to deliver stream in it's response
Api.streamRequestTo = Api.requestTo;
Api.streamRequest = Api.request;

Api.sendStream = function (method, params, cb) {
  Api.sendStreamTo(Api.defaultDevice, method, params, cb);
};


Api.setReSubscribe = function (s) {
  reSubscribeEnabled = s;
}

Api.sendStreamTo = function (deviceId, method, params, cb) {
  Api.requestTo(deviceId, method, params, function (err) {
    if (err) {
      cb(err, null)
    } else {
      var stream = ss.createStream();
      params.method = method;
      params.to = deviceId;
      deviceList[deviceId].streamSocket.emit('stream', stream, params);
      cb(null, stream);
    }
  }, true);
}

//old interface
Api.init = Api.connect

//Export api
module.exports = Api;



// WEBPACK FOOTER //
// ./modules/lcp-client-communication/index.js